import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <div className="glass-card rounded-lg p-8 md:p-12 mb-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
              Welcome to Vajreya Ventures
            </h1>
            <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed text-justify">
              Vajreya Ventures Private Limited serves as a dynamic management consultancy firm headquartered in Bangalore Karnataka, India. The company excels in strategic investments, acquiring shares, debentures, and securities in domestic and global entities, while underwriting, guaranteeing subscriptions, and managing subsidiaries. It provides comprehensive consultancy, advisory, and training services across its expertise in real estate, hospitality, infrastructure, and media, representing clients in international forums and negotiating agreements. Further, it facilitates mergers, joint ventures, financing, guarantees, trustee services, and arbitration, empowering clients with tailored financial and operational strategies worldwide.
            </p>
          </div>
        </div>

        {/* Key Services Overview - Now Clickable Links to Section Pages */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <Link to="/strategic-consulting" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Strategic Consulting and Management</h3>
            <p className="text-gray-600">Expert advisory services delivering strategic insights and operational excellence across diverse industries.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/investments-lending" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Investments and Lending</h3>
            <p className="text-gray-600">Comprehensive investment solutions and flexible lending services tailored to your financial growth objectives.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/construction-real-estate" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Construction and Real Estate</h3>
            <p className="text-gray-600">End-to-end property development and construction management services for premium residential and commercial projects.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/hospitality" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Hospitality and Media</h3>
            <p className="text-gray-600">Premium hospitality management and innovative media solutions creating exceptional experiences and compelling content.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/research" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Research and Global Operations</h3>
            <p className="text-gray-600">In-depth market research and international business operations connecting opportunities across global markets.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/intelligent-financing" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Intelligent Financing and Crypto</h3>
            <p className="text-gray-600">Cutting-edge financial solutions leveraging blockchain technology and cryptocurrency for modern investment strategies.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/precious-metals" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Precious Metals Trade</h3>
            <p className="text-gray-600">Strategic trading and investment in precious metals including gold, silver, platinum, and other valuable commodities.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          <Link to="/asset-administration" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Asset Administration and Management</h3>
            <p className="text-gray-600">Comprehensive asset management services ensuring optimal performance, compliance, and value preservation for your portfolio.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          {/* Our Team Card */}
          <Link to="/staff" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Our Team</h3>
            <p className="text-gray-600">Meet the experienced professionals driving excellence at Vajreya Ventures.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>

          {/* Contact Us Card */}
          <Link to="/contact" className="glass-card rounded-lg p-6 hover:shadow-xl transition-all transform hover:scale-105">
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-primary mb-2">Contact Us</h3>
            <p className="text-gray-600">Get in touch to discuss how we can help achieve your investment and business goals.</p>
            <p className="text-gold font-semibold mt-4 flex items-center">
              Learn More 
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </Link>
        </div>

        {/* Call to Action */}
        <div className="glass-card rounded-lg p-8 text-center">
          <h2 className="text-3xl font-bold text-primary mb-4">Ready to Explore Opportunities?</h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Discover how Vajreya Ventures can help you achieve your investment and business goals with our expertise in multiple sectors.
          </p>
          <a 
            href="/contact" 
            className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
          >
            Contact Us Today
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;